import { EventLocation } from "@circle-react/components/Events/NewEventsSpace/ListViewItem/EventLocation";

export const Location = ({ event }: any) => {
  const { event_setting_attributes: eventData } = event || {};

  const { location_type: locationType } = eventData || {};

  return <EventLocation type={locationType} />;
};
